import React from 'react';

function WhatIsSeoSection() {
  const handleQuoteClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  const handleWorkClick = (e) => {
    e.preventDefault();
    const portfolioEl = document.getElementById('seo-portfolio') || document.querySelector('.seo-portfolio-section');
    if (portfolioEl) {
      portfolioEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="what-is-seo-section">
      <div className="container what-is-seo-container">
        {/* Left Column: What Is SEO Infographic Image */}
        <div className="what-is-seo-left">
          <div className="what-is-seo-img-wrapper">
            <img
              src="/assets/images/seo-services/seo-img2.jpg"
              alt="What Is Search Engine Optimization"
              className="what-is-seo-img"
            />
          </div>
        </div>

        {/* Right Column: Title, Content, and 2 Buttons */}
        <div className="what-is-seo-right">
          <h2 className="what-is-seo-title">
            What Is <span className="what-is-seo-red-title">Search Engine Optimization?</span>
          </h2>

          <p className="what-is-seo-desc">
            SEO stands for Search Engine Optimization. It is the best way to increase the organic traffic of a website. SEO is a broad area with numerous strategies to improve a website’s organic position in search engine results. The strategies include on-page, off-page, and technical SEO. All the activities aim to achieve higher rankings for your products and services. <a href="/" className="seo-red-link">Experts Communication</a> offers SEO services in Pakistan to increase your website’s organic traffic and search engine rankings. Our team employs best practices such as on-page, off-page, and technical optimization, strategic keyword research, compelling content creation, and performance monitoring to make your site more visible on SERPs.
          </p>

          <div className="what-is-seo-btn-group">
            <button className="btn-seo-primary" onClick={handleQuoteClick}>
              Get Free Quote!
            </button>
            <a
              href="#seo-portfolio"
              className="btn-seo-outline"
              onClick={handleWorkClick}
            >
              See Our Work
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatIsSeoSection;
